import { inject, injectable } from 'inversify';
import Debug from 'debug';
import { QueryInteractionResultsTrackingQuery, QueryInteractionResultsTrackingQueryPayload,
         InteractionResult } from '../api'
import { InteractionSuspendDataStore2 } from '../common';
import { QueryHandler } from '@/app/tracking/common';

const debug = Debug('scorm2004-query-question-attempts-query-handler')

@injectable()
export class Scorm2004QueryInteractionResultsQueryHandler implements QueryHandler<QueryInteractionResultsTrackingQuery> {

  constructor (
    @inject(InteractionSuspendDataStore2)
    private store: InteractionSuspendDataStore2,
  ) {}
  
  public async execute(query: QueryInteractionResultsTrackingQueryPayload) {

    debug('execute', query)

    const interactionResults = await this.store.query('all')
    const mapped = interactionResults.map(x => {
      const result: InteractionResult = {
        id: x.id,
        status: x.status,
        progress: x.progress
      }

      return result

    })

    debug('interaction-results', mapped)

    return { interactionResults: mapped }
  }
}
